import { Controller } from "@hotwired/stimulus"

/**
 * Search Controller
 * 
 * Automatically focuses search input fields when they appear.
 * Provides enhanced search form functionality with automatic focus and selection.
 * 
 * Features:
 * - Automatically focuses empty search input fields on connect
 * - Selects all text in the input field for easy replacement
 * - Preserves existing values when input already has content
 * - Provides console logging for debugging search behavior
 * - Handles focus, blur, and value change events
 * 
 * Usage: Add data-controller="search" to search forms with input targets
 * 
 * Targets:
 * - input: The search input field to focus
 * 
 * Values:
 * - preserveValue: Boolean (default: true) - Whether to preserve existing input values
 */
export default class extends Controller {
  static targets = ["input"]
  static values = { 
    preserveValue: { type: Boolean, default: true }
  }

  connect() {
    this.focusInput()
  }

  focusInput() {
    if (!this.hasInputTarget) {
      console.warn("[SearchController] No input target found")
      return
    }

    const input = this.inputTarget
    if (!input.value) {
      setTimeout(() => {
        try {
          input.focus()
          input.select()
        } catch (e) {
          console.warn("[SearchController] Focus failed:", e)
        }
      }, 100)
    }
  }

  inputChanged() {}
  inputFocused() {}
  inputBlurred() {}
} 